export const DIRECTIVE_NAME = 'updSticky';
const CLASS_NAME = 'upd-sticky';

/**
 * This directive is our pseudo-polyfill for `position: sticky`. It's a difficult
 * feature to polyfill, as evidenced by the lack of solid polyfills out there
 * (`stickybits` came close).
 *
 * Usage:
 * `<div upd-sticky="expression"`> where `expression` resolves to the Y-position
 * (relative to the viewport) at which the element should add `upd-sticky`.
 *
 * Notes:
 *
 * 1. Does NOT add any behavior in browsers that support `sticky`. Some layout scenarios
 *    won't work if `upd-sticky` and `positon: sticky` are on the same element.
 *    Setting `position: sticky` should be done manually, using `@supports`.
 * 2. Adds the class `upd-sticky` when the topOffset condition is met
 * 3. Must specify `position: fixed/relative` in developer defined `upd-sticky` class
 *    properties. This allows you to use top/margin or whatever you want to position
 *    the element.
 */
export function sticky($parse) {
  'ngInject';
  return {
    restrict: 'A',
    link: ($scope, $element, $attr) => {
      const { CSS } = window;

      if (
        !(
          CSS &&
          CSS.supports &&
          CSS.supports('( position: sticky ) or ( position: -webkit-sticky )')
        )
      ) {
        let isToggled;
        const attrValue = $attr[DIRECTIVE_NAME];
        const element = $element[0];
        let scrollOffset = 0;

        window.addEventListener('scroll', onScroll);

        $scope.$on('$destroy', () =>
          window.removeEventListener('scroll', onScroll)
        );

        function onScroll() {
          // Setting default to something really high, effectively setting it to
          // fixed permanently when you pass in null
          const topOffset = parseInt($parse(attrValue)($scope), 10) || 99999;
          const { top } = element.getBoundingClientRect();
          const { pageYOffset } = window;

          if (!isToggled && top <= topOffset) {
            scrollOffset = pageYOffset;
            $element.addClass(CLASS_NAME);
            isToggled = true;
          } else if (isToggled && scrollOffset >= pageYOffset) {
            scrollOffset = 0;
            $element.removeClass(CLASS_NAME);
            isToggled = false;
          }
        }
      }
    },
  };
}
